module.exports = __webpack_public_path__ + "img/kafeizong.bbc41e02.png";